(() => {
  const init = root => {
    if (root.dataset.ready || !window.ItsPlannerQuiz) return;
    const engine = window.ItsPlannerQuiz;
    let catalog;
    try { catalog = JSON.parse(root.querySelector('[data-quiz-catalog]').textContent); } catch { return; }
    root.dataset.ready = 'true';
    const find = selector => root.querySelector(selector);
    const intro = find('[data-quiz-intro]');
    const form = find('[data-quiz-form]');
    const results = find('[data-quiz-results]');
    const questionArea = find('[data-quiz-question]');
    const next = find('[data-quiz-next]');
    let current = 0;
    let answers = Array(engine.questions.length).fill(null);
    const focus = element => {
      element.focus({ preventScroll: true });
      element.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    };
    const element = (tag, text, className) => {
      const node = document.createElement(tag);
      if (text) node.textContent = text;
      if (className) node.className = className;
      return node;
    };
    function showQuestion() {
      intro.hidden = true;
      results.hidden = true;
      form.hidden = false;
      questionArea.replaceChildren();
      const question = engine.questions[current];
      const fieldset = element('fieldset');
      const legend = element('legend', question.title);
      legend.tabIndex = -1;
      fieldset.append(legend);
      const options = element('div', '', 'its-quiz__options');
      question.answers.forEach((answer, index) => {
        const label = element('label', '', 'its-quiz__option');
        const input = element('input');
        input.type = 'radio';
        input.name = 'quiz-answer';
        input.value = index;
        input.checked = answers[current] === index;
        input.required = true;
        input.addEventListener('change', () => { answers[current] = index; next.disabled = false; });
        const letter = element('span', String.fromCharCode(65 + index), 'its-quiz__letter');
        letter.setAttribute('aria-hidden', 'true');
        label.append(input, letter, element('span', answer.text));
        options.append(label);
      });
      fieldset.append(options);
      questionArea.append(fieldset);
      find('[data-quiz-progress-text]').textContent = `PERGUNTA ${String(current + 1).padStart(2, '0')} / 08`;
      find('[data-quiz-progress]').value = current + 1;
      next.textContent = current === 7 ? 'Encontrar meu planner ✨' : 'Continuar →';
      next.disabled = answers[current] === null;
      focus(legend);
    }
    function renderCard(product, primary) {
      const data = catalog.entries.find(entry => entry.id === product.id) || {};
      const card = element('article', '', `its-quiz__match its-quiz__match--${product.line}`);
      card.dataset.resultId = product.id;
      const media = element('figure', '', 'its-quiz__match-media');
      if (data.image) {
        const img = element('img');
        img.src = data.image;
        img.alt = data.imageIsLayout ? `${product.lineName} ${product.sizeName} — ${product.layout}` : `Capa de referência — ${product.lineName} ${product.sizeName}`;
        img.width = 900;
        img.height = 1100;
        img.loading = primary ? 'eager' : 'lazy';
        media.append(img);
        media.append(element('figcaption', data.imageIsLayout ? product.layout : 'Capa de referência. Conheça as estampas disponíveis.'));
      } else {
        media.append(element('span', '2027', 'its-quiz__image-fallback'), element('figcaption', `${product.lineName} · ${product.sizeName}`));
      }
      const copy = element('div', '', 'its-quiz__match-copy');
      copy.append(element('p', primary ? '01 / MATCH PRINCIPAL' : '02 / OUTRA OPÇÃO QUE TAMBÉM COMBINA CONTIGO', 'its-eyebrow'));
      copy.append(element('h3', product.lineName), element('p', `${product.sizeName} | ${product.layout}`, 'its-quiz__layout'));
      const badges = element('div', '', 'its-quiz__badges');
      const badgesText = [product.sizeName, product.line === 'duo' ? 'Semanal + diária · 2 volumes' : product.line === 'multivisao' ? 'Visão integrada' : 'Visão semanal'];
      if (product.profile === 'diaria_livre') badgesText.push('Liberdade para escrever');
      if (product.profile === 'diaria_funcional') badgesText.push('Estrutura para o dia');
      badgesText.forEach(text => badges.append(element('span', text)));
      copy.append(badges, element('h4', 'Por que ele combina contigo?'), element('p', product.description));
      const url = catalog.destination === 'collection' ? data.collectionUrl : data.url || data.collectionUrl;
      if (url) {
        const link = element('a', primary ? 'CONHECER ESSE PLANNER ↗' : 'VER ESSA OPÇÃO ↗', 'button');
        link.href = url;
        copy.append(link);
        if (catalog.destination === 'collection') copy.append(element('p', 'Próximo passo: escolha a capa que combina contigo.', 'its-quiz__small'));
        if (!data.available) copy.append(element('p', 'Este modelo está indisponível no momento. Consulte as opções na loja.', 'its-quiz__small'));
        if (data.collectionUrl && catalog.destination !== 'collection') {
          const covers = element('a', 'Ver todas as capas deste tamanho →', 'its-quiz__covers');
          covers.href = data.collectionUrl;
          copy.append(covers);
        }
      } else copy.append(element('p', 'Este modelo ainda não está disponível na loja.'));
      card.append(media, copy);
      return card;
    }
    form.addEventListener('submit', event => {
      event.preventDefault();
      if (answers[current] === null) return;
      if (current < 7) { current += 1; showQuestion(); return; }
      const result = engine.rank(answers);
      find('[data-quiz-primary]').replaceChildren(renderCard(result.principal, true));
      find('[data-quiz-alternative]').replaceChildren(renderCard(result.alternative, false));
      find('[data-quiz-close]').hidden = !result.closeLines;
      form.hidden = true;
      results.hidden = false;
      focus(results.querySelector('h2'));
    });
    find('[data-quiz-back]').addEventListener('click', () => {
      if (current > 0) { current -= 1; showQuestion(); }
      else { form.hidden = true; intro.hidden = false; focus(intro.querySelector('h1')); }
    });
    find('[data-quiz-start]').hidden = false;
    find('[data-quiz-start]').addEventListener('click', showQuestion);
    find('[data-quiz-edit]').addEventListener('click', () => { current = 0; showQuestion(); });
    find('[data-quiz-reset]').addEventListener('click', () => {
      answers = Array(8).fill(null);
      current = 0;
      showQuestion();
    });
  };
  const boot = (scope = document) => scope.querySelectorAll('[data-planner-quiz]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', event => boot(event.target));
})();
